// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../services/authService';

export default function ProtectedRoute({ children }) {
  const tokenIsValid = isTokenValid();

  if (!tokenIsValid) {
    // If the token is invalid or missing, redirect to login
    return <Navigate to="/login" replace />;
  }

  // Else render the protected content
  return children;
}
